import React, { useEffect } from "react";
import { PageHeader } from "../../../CommonElements/PageTitle";
import { useTranslation } from "react-i18next";
import { HousingInspectionList } from "./HousingInspectionList";
import { Tabs } from "antd";
import { useCachedBasicData } from "@/utils/hooks/useCachedBasicData";
import { useLocalizedText } from "@/utils/hooks/useLocalizedText";
import { Container } from "reactstrap";
import { useHousingInspectionContext } from "./HousingInspectionContext/housingContext";
import { EXAMINATION_TYPES } from "@/utils/constants";

const HousingInspection = () => {
  // ==================
  // Hooks
  // ==================
  const { t } = useTranslation();
  const { getLocalizedText } = useLocalizedText();

  const { cachedBasicData, houseExaminationsDataResponse } =
    useCachedBasicData();
  const { inspectionState, searchParams, handleTabChange } =
    useHousingInspectionContext();
  const { selectedInspections, type } = inspectionState;

  const { examination_statuses } = cachedBasicData;
  const { isLoading } = houseExaminationsDataResponse;

  const activeTab =
    !!selectedInspections?.length &&
    type !== EXAMINATION_TYPES.track &&
    !["not_registered", "completed"].includes(searchParams.get("tab") || "")
      ? "not_registered"
      : searchParams.get("tab") || "all";

  useEffect(() => {
    if (
      activeTab === "not_registered" &&
      searchParams.get("tab") !== "not_registered"
    )
      handleTabChange("not_registered");
  }, []);

  const tabItems = [
    {
      key: "all",
      label: t("ALL"),
    },
    ...(examination_statuses?.map?.((status) => ({
      key: status.value,
      label: getLocalizedText(status.label_ar, status.label_en),
    })) || []),
  ];

  return (
    <div>
      <PageHeader title={t("HOUSING_INSPECTION")} sticky={false} />
      <Container fluid>
        <Tabs
          items={tabItems.map((item) => ({
            ...item,
            disabled:
              isLoading ||
              (!!selectedInspections?.length &&
                type !== EXAMINATION_TYPES.track),
          }))}
          className="mb-3"
          onChange={handleTabChange}
          activeKey={activeTab}
        />
        <HousingInspectionList />
      </Container>
    </div>
  );
};

export default HousingInspection;
